// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vrwpe","star":"styles_star__VvNt8"};